import { Injectable, Inject } from 'ng-metadata/core';
import { HttpService } from '../../../infra/httpRequest/http.service';
import {FormBuilderEnums} from '../../../infra/formBuilder/formBuilder.service';
const get= require('lodash/get');


@Injectable()
export class SelfRegistrationService {

    private createNewUserUrl:any;
    private getCountryListUrl:any;
    private selfRegistrationFormMessages:any;
    
    constructor (private httpService: HttpService,
        @Inject('restBaseURLs') private restBaseURLs) {
        this.createNewUserUrl = restBaseURLs.createNewUserURL;
        this.getCountryListUrl = restBaseURLs.getCountryListUrl;
        this.selfRegistrationFormMessages = restBaseURLs.selfRegistrationFormMessagesURL;
    }

    public createNewUser(formData) {
        let params = {
            registrationType: formData['registrationType'],
            userName: formData['userName'],
            password : formData['password'],
            companyName : formData['companyName'],
            firstName : formData['firstName'],
            lastName : formData['lastName'],
            email : formData['email'],
            addressLine1 : formData['addressLine1'],
            addressLine2 : formData['addressLine2'],
            city : formData['city'],
            state : formData['state'],
            zipCode : formData['zipCode'],
            country : formData['country'],
            primaryContactFirstName : formData['primaryContactFirstName'],
            primaryContactLastName : formData['primaryContactLastName'],
            primaryContactEmail : formData['primaryContactEmail'],
            phoneNumber : formData['phoneNumber'],
            maximumRequestCost : formData['maximumRequestCost'],
            billingContactName : formData['billingContactName'],
            billingEmailAddress : formData['billingEmailAddress'],
            billingAddressLine1 : formData['billingAddressLine1'],
            billingAddressLine2 : formData['billingAddressLine2'],
            billingCity : formData['billingCity'],
            billingStateProvince : formData['billingStateProvince'],
            billingPostalCode : formData['billingPostalCode'],
            billingCountry : formData['billingCountry'],
            billingComplianceStatement : formData['billingComplianceStatement']
        };
        return this.makeIlsRequest(this.createNewUserUrl, 'POST', params)
            .then(
                (response)=> {
                    if(response && response.status && response.status == '422'){
                        return {status:"error", data:response.data};
                    }
                    return {status:"success", data:response};
                },
                (error)=>{
                    console.log('Failed to create new user: ');
                    console.log(error);
                }
            );
    }

    public getCountryList() {
        return this.makeIlsRequest(this.getCountryListUrl, 'GET', {});
    }

    public getFormMessages() {
        return this.makeIlsRequest(this.selfRegistrationFormMessages, 'GET', {});
    }

    makeIlsRequest(path, method, params) {
        if (!params) {
            params = {};
        }

        return this.httpService.call(method, path, params)
            .then(
                (response) => {
                    return this.ilsRequestSuccess(response);
                },
                (error) => {
                    return this.ilsRequestFailure(error, params);
                }
            );
    }

    private ilsRequestSuccess(response) {
        return response;
    }

    private ilsRequestFailure(reason, params) {
        console.error(reason);
        return reason;
    }

}




// WEBPACK FOOTER //
// ./src/main/webapp/components/security/login/selfRegistration/selfRegistration.service.ts